module.exports = __webpack_public_path__ + "static/media/New.f24defc1.svg";